import type { CreatureMainWeaponDamageTypeInput } from '../types';

export const MAIN_HAND_SLOT_ID = 'CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD';
export const OFF_HAND_SLOT_ID = '4FF85144-67EC-9D87-AE28-15137A1A2481';
export const BOTH_HANDS_SLOT_ID = 'E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D';
export const BLUDGEONING_DAMAGE_TYPE_ID = '0C528CF8-1B5A-453C-9BDE-73CBBC239A2A';

/** Select the primary held weapon damage type, or the production bludgeoning fallback. */
export function compileCreatureMainWeaponDamageType(input: CreatureMainWeaponDamageTypeInput): string {
    let selectedSlot = '';
    if (input.mainHandWeaponCount === 1 && input.inventoryRows.length > 0) selectedSlot = MAIN_HAND_SLOT_ID;
    else if (input.offHandWeaponCount === 1 && input.inventoryRows.length > 0) selectedSlot = OFF_HAND_SLOT_ID;
    else if (input.bothHandsWeaponCount === 1 && input.inventoryRows.length > 0) selectedSlot = BOTH_HANDS_SLOT_ID;

    if (selectedSlot !== '') {
        for (const row of input.inventoryRows) {
            if (row.equippedSlot === selectedSlot && row.itemType === 'weapon' && row.damageType !== null) return row.damageType;
        }
    }
    return BLUDGEONING_DAMAGE_TYPE_ID;
}
